export enum EnvironmentEnum {
    Development = 'development',
    Test = 'test',
    Production = 'production'
}
